import React from 'react'

import PropTypes from 'prop-types'

import {
  ReservationCanReject,
  ReservationHowToRecoverMoney,
  ReservationImportantAspects,
  ReservationInfo,
  ReservationLegalConditionsLink,
  ReservationTcAdevinta,
  ReservationTerms,
  ReservationUserResponsibility
} from '@adv-mt/mt-react-markdown'

import Wrapper from '../wrapper.js'

const contentMap = {
  'reservation-legal-conditions': ReservationTcAdevinta,
  'reservation-info': ReservationInfo,
  'reservation-terms': ReservationTerms,
  'reservation-can-reject': ReservationCanReject,
  'reservation-how-to-recover-money': ReservationHowToRecoverMoney,
  'reservation-user-responsibility': ReservationUserResponsibility,
  'reservation-important-aspects': ReservationImportantAspects,
  'reservation-legal-conditions-link': ReservationLegalConditionsLink
}

const MarkdownReservationTc = ({documentName, tenant, parser}) => {
  const Content = contentMap[documentName] ?? ReservationTcAdevinta

  return (
    <Wrapper>
      <Content tenant={tenant} parser={parser} />
    </Wrapper>
  )
}

MarkdownReservationTc.displayName = 'MarkdownReservationTc'

MarkdownReservationTc.propTypes = {
  documentName: PropTypes.string.isRequired,
  tenant: PropTypes.string,
  parser: PropTypes.func
}

export default MarkdownReservationTc
